import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import STC from '../../../STCLibrary/STCFactory/STCFactory';
import './Verification.css';
import { VerifyAPIs } from '../../../API/VerifyAPIs/VerifyAPIs';
import NotificationContext from '../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import Logo from '../../../Resources/Logo/LogoBordered.png'
import ColouredLoadingSymbol from '../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';

export default function Verification() {

    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();
    const routeParams = useParams();

    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    const successMsg = 'Email successfully verified! You can now access your account from the login screen.'
    const errorMsg = 'There was a problem verifying your email address. Please try again later or contact us on '


    const sendVerificationCode = (token) => {
        //Send api with the token
        VerifyAPIs.PostVerify(token)
        .then((response) => {
            if(response.status === 200 && response.data !== "" ){
                setSuccess(true);
            }
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setLoading(false);
            ApiResponseHandler(err.response, notificationCtx, navigate)
        })

    }
  
    useEffect(() => {
        sendVerificationCode(routeParams.verificationCode);
    }, [routeParams.verificationCode])
  
    return (
        <div className="login-container">
            <div className="coloured-box-container">
                <div className='coloured-box'></div>
            </div>


            <div className='login-form-container'>

                  
                <div className='login-form-card'>
                {loading ? 
                
                <div>
                    <ColouredLoadingSymbol/>
                </div>
                : <>
                    <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                        <img src={Logo} alt="LogoBordered" className="LogoBordered" />
                    </div>
                    <div className="m-2">
                        <div className='mt-2'>
                            <STC.Alert variant={success ? 'success' : 'danger'}>
                                {success ? successMsg : errorMsg} {!success && <strong>info@schooltour.ie</strong>}
                            </STC.Alert>
                        </div>
                        <div className="mt-2 text-center">
                            <span
                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                onClick={()=> navigate('/')}
                            >
                                Return to Login
                            </span>
                        </div>
                    </div>
                    </>
                    }
                </div>
                
            </div>
        </div>
    );
}
